/**
 * ticketAutomation.js — la definición de «este ticket está automatizado», en el navegador.
 *
 * ESPEJO de `backend/src/modules/ticket-routing/services/TicketAutomationPredicate.service.ts`.
 * Los dos proyectos no comparten código, así que la definición vive por duplicado. **Si se
 * cambia una, hay que cambiar la otra.**
 *
 * 📌 Destino: que el backend envíe el ticket ya resuelto y el navegador no calcule nada. Hasta
 * entonces, este archivo es el único sitio del frontend donde se decide.
 *
 * Antes de 0424 F0 había cuatro versiones repartidas por el frontend, dos de ellas en el mismo
 * componente, y ninguna coincidía del todo.
 */

/**
 * ¿El ticket tiene alguna automatización configurada?
 *
 * ⚠️ `useIntegration` no vale por sí solo: el resolver del backend lo deja en `false` para
 * FlowBuilder y para Chatbot, que están automatizados igualmente. Se mantiene en la unión por
 * compatibilidad con datos heredados.
 *
 * 📌 `flowStatus` pertenece a FlowBuilder: aquí solo se lee. Ver el contrato en 0424 §6.9.
 */
export const hasAutomation = (ticket) => {
  if (!ticket) return false;
  return (
    ticket.promptId != null ||
    ticket.chatbot === true ||
    ticket.integrationId != null ||
    ticket.flowStatus != null ||
    ticket.useIntegration === true
  );
};

/**
 * ¿Manda el bot ahora mismo?
 *
 * Un ticket con agente humano asignado no lo lleva el bot, aunque conserve los flags. Esa regla
 * se descubrió dos veces por separado —en el teclado del agente y en el backend— y es la misma.
 */
export const isBotInControl = (ticket) => {
  if (!ticket) return false;
  return hasAutomation(ticket) && !ticket.userId;
};
